export default function ({ res }) {
  if (process.server) {
    res.setHeader('X-Frame-Options', 'SAMEORIGIN');
  }
}
